import { Tags } from "../../enum/tags";
import { apiSlice } from "../http";

export const metabaseInformations = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getMetabase: builder.query<any, { id: number }>({
      query: ({ id }) => {
        return {
          url: `/metabase/${id}`,
          method: "GET",
        };
      },
      providesTags: [Tags.METABASE],
    }),
  }),
  overrideExisting: true,
});

export const { useGetMetabaseQuery } = metabaseInformations;

export const {
  endpoints: {
    getMetabase: { select: selectGetMetabase },
  },
} = metabaseInformations;
